/** Match historical/live readings to the sensors chosen in the filter bar. */

const normalizeId = (value) => {
  if (value == null || value === '') return '';
  if (typeof value === 'object') {
    if (value._id != null) return String(value._id);
    if (typeof value.toString === 'function') {
      const asString = value.toString();
      if (asString && asString !== '[object Object]') return asString;
    }
  }
  return String(value);
};

const isPlottableNumber = (value) =>
  value != null && value !== '' && !Number.isNaN(Number(value));

export const readingMatchesSelectedSensors = (reading, sensorIds = [], sensorSerials = []) => {
  if (!sensorIds.length && !sensorSerials.length) return true;
  const readingSensorId = normalizeId(reading?.sensorId || reading?._id);
  if (readingSensorId && sensorIds.includes(readingSensorId)) return true;
  const serial = reading?.sensorSerialNo != null ? String(reading.sensorSerialNo) : '';
  if (serial && sensorSerials.includes(serial)) return true;
  if (readingSensorId && sensorSerials.includes(readingSensorId)) return true;
  return false;
};

/** True when a reading has accelerometer axes (temperature-only rows are excluded). */
export const readingHasAccelAxes = (reading) =>
  isPlottableNumber(reading?.xAxis)
  || isPlottableNumber(reading?.yAxis)
  || isPlottableNumber(reading?.zAxis);

/** Carry last X/Y/Z forward so a single-sensor live chart stays continuous. */
export const fillSingleSensorAccelGaps = (points) => {
  if (!points?.length) return points;
  const fields = ['xAxis', 'yAxis', 'zAxis'];
  const filled = points.map((point) => ({ ...point }));
  fields.forEach((field) => {
    let lastVal;
    for (let i = 0; i < filled.length; i += 1) {
      if (isPlottableNumber(filled[i][field])) lastVal = filled[i][field];
      else if (lastVal !== undefined) filled[i][field] = lastVal;
    }
  });
  return filled;
};

export const getLatestBatteryReading = (rows, sensorIds, sensorSerials, liveReading) => {
  const fromHistory = [...(rows || [])]
    .filter((d) => (
      d.batteryVoltage != null
      && readingMatchesSelectedSensors(d, sensorIds, sensorSerials)
    ))
    .pop();
  if (fromHistory?.batteryVoltage != null) return fromHistory;
  if (liveReading?.batteryVoltage != null) return liveReading;
  return null;
};
